import apiBonus from '@/api/vo/bonus';

const defaultState = () => ({
	listSummaryBonus: [],
	listBonusToday: [],
	listHistoryBonus: [],
	historyBonusPagination: '',
	listHistoryTransfer: [],
	historyTransferPagination: '',
	detailHistoryTransfer: {},
	responSukses: {},
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setSummaryBonus(state, data) {
		state.listSummaryBonus = data;
	},
	setBonusToday(state, data) {
		state.listBonusToday = data.data;
	},
	setHistoryBonus(state, data) {
		state.listHistoryBonus = data.data;
		state.historyBonusPagination = data.pagination;
	},
	setHistoryTransfer(state, data) {
		state.listHistoryTransfer = data.data;
		state.historyTransferPagination = data.pagination;
	},
	setDetailHistoryTransfer(state, data) {
		state.detailHistoryTransfer = data.data;
	},
	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
	},
};

const actions = {

	getSummaryBonus({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiBonus.getSummaryBonus(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSummaryBonus', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSummaryBonus', []);
				reject()
			});
		});
	},

	getDetailBonusToday({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiBonus.getDetailBonusToday(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setBonusToday', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setBonusToday', []);
				reject()
			});
		});
	},

	getHistoryBonus({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiBonus.getHistoryBonus(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryBonus', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryBonus', { data: [], pagination: {} });
				reject()
			});
		});
	},
	
	getHistoryTransfer({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiBonus.getHistoryTransfer(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryTransfer', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryTransfer', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getDetailHistoryTransfer({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiBonus.getDetailHistoryTransfer(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailHistoryTransfer', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDetailHistoryTransfer', {});
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;

			}
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};